import { Suspense, lazy } from 'react'
import { cn } from '@/ui/lib/utils'
import { ErrorBoundary } from '@/ui/ErrorBoundary'
import type { QuantLightChartProps } from '@/ui/QuantLightChart'

export type { QuantLightChartProps } from '@/ui/QuantLightChart'
export type { ChartViewCommand, QuantChartApi, QuantViewChange } from '@/ui/lib/quantChart/controller'

// The library is about 195 KB raw: a dynamic import keeps it out of the entry
// bundle (spec 038 findings P0a, lazy shape: a lazy wrapper inside `src/ui/`).
const LazyChart = lazy(() => import('@/ui/QuantLightChart').then((m) => ({ default: m.QuantLightChart })))

/**
 * The chart to use from screens: loads `QuantLightChart` on first render. The
 * fallback is a fixed-size ink box that fills the same container, so nothing
 * resizes when the library arrives.
 */
export function QuantChart(props: QuantLightChartProps) {
  return (
    <ErrorBoundary
      label="Chart"
      className={cn('relative flex h-full w-full items-center justify-center overflow-hidden bg-ink font-mono text-[12px] text-paper-50', props.className)}
    >
      <Suspense
        fallback={
          <div role="status" aria-label="Loading chart" className={cn('relative h-full w-full overflow-hidden bg-ink', props.className)} />
        }
      >
        <LazyChart {...props} />
      </Suspense>
    </ErrorBoundary>
  )
}
